export const TREE_ADDRESS_PRESETS = ['LL', 'LR', 'RL', 'RR'] as const

export type TreeAddressPreset = (typeof TREE_ADDRESS_PRESETS)[number]
export type TreeLeaf = 'a' | 'b' | 'c' | 'd'

const LEAF_BY_ADDRESS: Record<TreeAddressPreset, TreeLeaf> = {
  LL: 'a',
  LR: 'b',
  RL: 'c',
  RR: 'd',
}

const DIRECTIONS_BY_ADDRESS: Record<TreeAddressPreset, ('L' | 'R')[]> = {
  LL: ['L', 'L'],
  LR: ['L', 'R'],
  RL: ['R', 'L'],
  RR: ['R', 'R'],
}

export function expectedLeafForAddress(address: TreeAddressPreset): TreeLeaf {
  return LEAF_BY_ADDRESS[address]
}

export function directionsForAddress(address: TreeAddressPreset): ('L' | 'R')[] {
  return [...DIRECTIONS_BY_ADDRESS[address]]
}

export function displayAddress(address: TreeAddressPreset): string {
  return `${address[0]} → ${address[1]}`
}
